/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAnalyticEventRemoteAudioStatsMeasuredFromJSON(json) {
    return StreemApiAnalyticEventRemoteAudioStatsMeasuredFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventRemoteAudioStatsMeasuredFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'packetsLost': !exists(json, 'packets_lost') ? undefined : json['packets_lost'],
        'codec': !exists(json, 'codec') ? undefined : json['codec'],
        'bytesReceived': !exists(json, 'bytes_received') ? undefined : json['bytes_received'],
        'packetsReceived': !exists(json, 'packets_received') ? undefined : json['packets_received'],
        'audioLevel': !exists(json, 'audio_level') ? undefined : json['audio_level'],
        'jitterMs': !exists(json, 'jitter_ms') ? undefined : json['jitter_ms'],
        'trackSid': !exists(json, 'track_sid') ? undefined : json['track_sid'],
        'roomSid': !exists(json, 'room_sid') ? undefined : json['room_sid'],
    };
}
export function StreemApiAnalyticEventRemoteAudioStatsMeasuredToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'packets_lost': value.packetsLost,
        'codec': value.codec,
        'bytes_received': value.bytesReceived,
        'packets_received': value.packetsReceived,
        'audio_level': value.audioLevel,
        'jitter_ms': value.jitterMs,
        'track_sid': value.trackSid,
        'room_sid': value.roomSid,
    };
}
//# sourceMappingURL=StreemApiAnalyticEventRemoteAudioStatsMeasured.js.map